import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { formatNumber } from '@/utils/statisticsFormatters';
import { CustomTooltip } from './CustomTooltip';

interface ResourcesUsageChartProps {
  data: { date: string; input: number; output: number; total: number }[];
}

export const ResourcesUsageChart = ({ data }: ResourcesUsageChartProps) => {
  const chartConfig = {
    input: {
      label: 'Tokens Input',
      color: 'hsl(221.2 83.2% 53.3%)',
    },
    output: {
      label: 'Tokens Output',
      color: 'hsl(262.1 83.3% 57.8%)',
    },
  };

  return (
    <ChartContainer config={chartConfig} className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => {
              const date = new Date(value);
              return `${date.getDate()}/${date.getMonth() + 1}`;
            }}
          />
          <YAxis
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => formatNumber(value)}
          />
          <Tooltip content={<CustomTooltip formatter={formatNumber} />} />
          <Legend />
          <Area
            type="monotone"
            dataKey="input"
            stackId="1"
            stroke="hsl(221.2 83.2% 53.3%)"
            fill="hsl(221.2 83.2% 53.3%)"
            fillOpacity={0.6}
            animationDuration={1000}
          />
          <Area
            type="monotone"
            dataKey="output"
            stackId="1"
            stroke="hsl(262.1 83.3% 57.8%)"
            fill="hsl(262.1 83.3% 57.8%)"
            fillOpacity={0.6}
            animationDuration={1000}
          />
        </AreaChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
